<template>
  <div class="home">
    <el-container class="big_box">
      <el-header>
        <div class="her_r">
          <img src="../assets/img/logo2.png" alt="" />
          <h2>论文投稿系统</h2>
        </div>
        <div class="f-r">
          <div class="her_l1" @click="jump()">
            <img src="../assets/img/return.jpg" alt="" />
          </div>
          <div class="her_l" @click="loginOut()">
            <p>注销</p>
            <img src="../assets/img/zuxiao_icon.png" alt="" />
          </div>
        </div>
      </el-header>
      <router-view></router-view>
    </el-container>
    <div class="footer">
      <p class="p-30">
        Copyright (c) 2020   京ICP备15005281号-1 All Rights Reserved
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  methods: {
    jump () {
      window.location.href = 'http://meeting2023.tdmchina.org/'
      // window.open('http://meeting2021.tdmchina.org')
    },
    loginOut () {
      this.$router.push('/login')
      window.localStorage.clear()
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>
<style lang="less" scoped>
.f-r {
  display: flex;
}
.big_box {
  // height: 100%;
  background-color: #f6fbff;
}
/deep/.el-aside {
  height: 810px;
}
.footer {
  height: 98px;
  width: 100%;
  background-color: #fff;
  // line-height: 90px;
  padding-left: 360px;
  box-sizing: border-box;
  color: #aaaaaa;
  // position: absolute;
  // bottom: 0;
  .p-30 {
    padding-top: 20px;
    box-sizing: border-box;
  }
  .p-10 {
    padding-top: 10px;
    box-sizing: border-box;
  }
}
/deep/.el-footer {
  width: 952px;
  // height: 344px !important;
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  min-height: 300px;
  // overflow-y: scroll;
}
/deep/.el-main {
  height: 50px;
  max-height: 50px !important;
  width: 100%;
  // min-width:  100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow-y: hidden;
  padding: 20px 0;
  .r_btn {
    width: 350px;
    height: 50px;
    display: flex;
    justify-content: space-between;
  }
  .r_tle {
    width: 223px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      font-size: 24px;
      margin-top: 3px !important;
      color: #00599e;
    }
    p {
      font-family: SourceHanSansCN-Regular;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;
      margin-left: 2px;
    }
    span {
      font-family: SourceHanSansCN-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #888888;
      margin-top: 9px;
    }
  }
}
.home {
  width: 100%;
  height: 100%;
  position: relative;

  .box {
    padding: 0 360px;
    box-sizing: border-box;
    margin-top: 70px;
    background: #f6fbff;
    // height: 872px !important;
  }
  /deep/.el-header {
    height: 100px !important;
    width: 100%;
    background: #fff;
    padding: 0 360px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .her_l1 {
      width: 165px;
      height: 50px;
      border-radius: 5px;
      overflow: hidden;
      margin-right: 10px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .her_l {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 130px;
      height: 50px;
      background-color: #00599e;
      border-radius: 5px;
      text-align: center;
      letter-spacing: 0px;
      color: #ffffff;
      font-size: 20px;
      line-height: 50px;
      cursor: pointer;

      p {
        margin-right: 13px;
      }
    }
    .her_r {
      display: flex;
      align-items: center;
      h2 {
        font-family: 'SourceHanSansCN-Medium';
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        margin-left: 21px;
      }

      img {
        display: block;
        width: 77px;
        height: 76px;
      }
    }
  }
  /deep/.el-aside {
    width: 220px !important;
  }
  /deep/.r_box {
    width: 952px !important;
    margin-left: 28px;
  }
  /deep/.el-menu {
    background: transparent !important;
    border-right: 0;
  }
  /deep/.el-submenu__title {
    height: 60px;
    line-height: 60px;
    background-color: #00599e;
    color: #fff;
  }
  /deep/.el-menu-item {
    min-width: 220px !important;
    color: #00599e;
    background-color: #f2f6f9;
  }
  /deep/.is-active {
    background-color: #84afd7 !important;
  }

  /deep/.is-active > i {
    color: #fff !important;
  }
  /deep/.el-menu-item-group__title {
    height: 6px;
    background: #f6fbff;
  }
  /deep/.el-submenu__title i {
    color: #fff;
  }
  /deep/.el-menu-item i {
    color: #00599e;
  }
}
</style>
